import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Base absolue du site (sert pour canonical + Open Graph).
// À garder cohérent avec le domaine configuré sur Vercel.
const SITE = "https://ml-agence.fr";
const BRAND = "ML. Agence Web";
const DEFAULT_DESC =
  "Agence web indépendante basée à Paris, au service de toute la France et de la francophonie. Création de sites internet rapides, designés, optimisés SEO et pensés pour convertir vos visiteurs en clients.";
const DEFAULT_IMAGE = SITE + "/og-image.png";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Composant SEO sans dépendance : met à jour dynamiquement le <title>,
 * la meta description, la balise canonical, les balises Open Graph / Twitter
 * et robots à chaque changement de page.
 */
export default function Seo({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  noindex = false,
  type = "website",
}) {
  const { pathname } = useLocation();

  useEffect(() => {
    const fullTitle = title
      ? `${title} — ${BRAND}`
      : `${BRAND} — Création de site internet · France & francophonie`;
    const url = SITE + (pathname === "/" ? "" : pathname);

    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertCanonical(url);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:site_name", BRAND);
    upsertMeta("property", "og:locale", "fr_FR");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);
  }, [title, description, image, noindex, type, pathname]);

  return null;
}
